import { toast } from '@codes/ui-kit/components/ui/use-toast';
import { BillingView } from '@lemoncloud/lemon-billings-api';
import { Params } from '@lemoncloud/lemon-web-core';
import { useQuery } from '@tanstack/react-query';

import { PaginationType, useCustomMutation } from '@codes/shared';

import { createBilling, deleteBilling, fetchBillingById, fetchBillings, updateBilling } from '../apis';
import { billingsKeys } from '../consts';
import { CreateBillingDTO, UpdateBillingDTO } from '../types';

export const useBillings = (params: Params) =>
    useQuery<PaginationType<BillingView[]>>({
        queryKey: billingsKeys.list(params ?? {}),
        queryFn: async () => {
            const result = await fetchBillings(params);
            return { ...result, data: result.list || [] } as PaginationType<BillingView[]>;
        },
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        staleTime: 0,
    });

export const useCreateBilling = () => {
    return useCustomMutation((data: CreateBillingDTO) => createBilling(data), {
        onError: error => {
            toast({ title: `${error?.toString()}` });
        },
    });
};

export const useBilling = (billingId: string) =>
    useQuery<BillingView>({
        queryKey: billingsKeys.detail(billingId),
        queryFn: () => fetchBillingById(billingId),
        refetchOnWindowFocus: false,
        enabled: !!billingId,
        refetchOnMount: true,
        staleTime: 0,
    });

export const useUpdateBilling = () => {
    return useCustomMutation((data: UpdateBillingDTO) => updateBilling(data), {
        onError: error => {
            toast({ title: `${error.toString()}` });
        },
    });
};

export const useDeleteBilling = () => {
    return useCustomMutation((id: string) => deleteBilling(id), {
        onError: error => {
            toast({ title: `${error.toString()}` });
        },
    });
};
